import { Component, OnInit, Inject, ChangeDetectionStrategy, AfterViewChecked, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MatSelectionList, MatSelectionListChange, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroupDirective, FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { SiteModel, Attachment, SiteStepperModel } from 'src/app/models/index';
import { SiteService, LoadService, CommonService } from 'src/app/services/index';
import { AlertService, SiteStepperEnum, Constants, Moment$, ActionModeEnum } from 'src/app/shared';
@Component({
  selector: 'app-add-node-detail-modal',
  templateUrl: './add-node-detail-modal.component.html',
  styleUrls: ['./add-node-detail-modal.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNodeDetailModalComponent implements OnInit, AfterViewChecked, AfterViewInit {

  public selectedDivID: string;
  public siteId: string;
  public immediateChildNodes: any;

  immediateChildEntites = [];
  loadAttachment: Attachment = new Attachment();
  sensorConnectedToGenericLoad: any;
  formData: FormGroup;
  nodeDetails: any;
  actionMode: ActionModeEnum = ActionModeEnum.Creating;
  get getActionModeEnum() {return ActionModeEnum; }
  requiredValidators = [Validators.required];
  node: any;
  constructor(private dialogRef: MatDialogRef<AddNodeDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private loadService: LoadService,
    private commonService: CommonService,
    private cdRef: ChangeDetectorRef,
    private siteService: SiteService, private alertService: AlertService) {
      this.initNodeDetailsObj();
      if (this.data) {
        if (this.data.nodeDetail.actionMode === ActionModeEnum.Editing) {
          this.nodeDetails = data.nodeDetail;
          this.actionMode = ActionModeEnum.Editing;
          this.nodeDetails.actionMode = this.actionMode;
        }
        this.siteId = data.siteId,
        this.immediateChildNodes = data.nodeDetail.immediateChildNodes;
        this.node = data.nodeData;
      }
    }

  ngOnInit() {
    this.formData = this.fb.group({
      nodeNameCtr: [, [Validators.required, Validators.minLength(2), Validators.maxLength(20)]],
      // selectedEnityCtr: [, [Validators.required]],
      selectedEnityCtr: [''],
      selectedsensorRIdCtr: ['']
    });
    this.getEntityList();
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
 }
 ngAfterViewInit() {
  this.cdRef.detectChanges();
 }
  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: null });
  }
  private initNodeDetailsObj = () => {
    this.nodeDetails = {};
    this.nodeDetails.nodeId = new Date().getTime(),
    this.nodeDetails.nodeName = null;
    this.nodeDetails.selectedEnity = '';
    this.nodeDetails.assignSensor = false;
    this.nodeDetails.sensorRIdForSelectedEnity = '';
    this.nodeDetails.actionMode = this.actionMode;
  }
  public addNodeLabel = () => {
    this.commonService.sendNodeTreeDetailSubject(this.nodeDetails);
    this.dialogRef.close();
  }
  public delete = (e: any) => {
    e.preventDefault();
    this.nodeDetails.actionMode = ActionModeEnum.Deleting;
    this.commonService.sendNodeTreeDetailSubject(this.nodeDetails);
    this.dialogRef.close();
  }
  // addNodeLabel() {
  //   const nodeName = this.nodeDetails.nodeName;
  //   const childEntityRId = this.nodeDetails.selectedEnity;
  //   const params = {
  //     'loadImgRId': this.loadAttachment.id,
  //     'NodeName': this.nodeDetails.NodeName,
  //     'ChildEntityRId': this.nodeDetails.selectedEnity,
  //     'assignSensor': this.nodeDetails.assignSensor,
  //     'sensorRId': this.nodeDetails.sensorRIdForSelectedEnity,
  //     'Type': Constants.DOCUMENT_TYPE.CLICK_AND_NAVIGATE_LAYOUT
  //   };
  //   this.loadService.addNodeForLoad(params).subscribe(data => {
  //     if (data.AddNodeStatus !== 'Fail') {
  //       let ngClickFunction = '';
  //       let labelTag = '';
  //       if (data.NodeClass === 'Load') {
  //         ngClickFunction = 'getDataOnClickAndNavigateLabelClick(' + data.NodeRId + ',' + nodeName + ','
  //           + childEntityRId + ',' + data.NodeClass + ',false)';
  //         labelTag = '<label class="loadLabel" (click)="' + ngClickFunction + '">' + nodeName + '</label>';
  //       } else if (data.NodeClass === 'Sensor') {
  //         const ngBind = this.nodeDetails.sensorRIdForSelectedEnity.replace('#', '').replace(':', '');
  //         labelTag = '<label tooltip="' + nodeName + ' id="' + this.nodeDetails.sensorRIdForSelectedEnity + '" ng-bind-html="SensorRID"'
  //           + ngBind + ' class="sensorLabel">' + nodeName + '</label>';
  //       } else {
  //         ngClickFunction = 'getDataOnClickAndNavigateLabelClick(' + data.NodeRId + ',' + nodeName + ',' +
  //           childEntityRId + ',' + data.NodeClass + ',false)';
  //         labelTag = '<label class="levelLabel" (click)="' + ngClickFunction + '">' + nodeName + '</label>';
  //       }

  //       this.alertService.showSuccess('Node Added Successfully..!!');
  //       this.dialogRef.close({ status: true, data: { labelTag: labelTag } });
  //     } else {

  //       this.alertService.showError('Failed to add Node..!!');
  //     }
  //   });
  // }
  private removeAllValidatorCtr = () => {
    const selectedEnityCtr = this.formData.get('selectedEnityCtr');
    selectedEnityCtr.setValidators(null);
    selectedEnityCtr.updateValueAndValidity();
    const selectedsensorRIdCtr = this.formData.get('selectedsensorRIdCtr');
    selectedsensorRIdCtr.setValidators(null);
    selectedsensorRIdCtr.updateValueAndValidity();
  }
  private setValidatorCtr = () => {
    const selectedEnityCtr = this.formData.get('selectedEnityCtr');
    selectedEnityCtr.setValidators(this.requiredValidators);
    selectedEnityCtr.updateValueAndValidity();
    const selectedsensorRIdCtr = this.formData.get('selectedsensorRIdCtr');
    selectedsensorRIdCtr.setValidators(this.requiredValidators);
    selectedsensorRIdCtr.updateValueAndValidity();
  }

  public getEntityList = () => {
    this.removeAllValidatorCtr();
    this.immediateChildEntites = this.immediateChildNodes;
    if (this.nodeDetails.assignSensor === true) {
      this.setValidatorCtr();
      const params = {
        'siteID': this.siteId,
        'type': Constants.LOAD_TYPE.GENERIC_OR_AREA_SPECIFIC_SENSOR.TYPE_VALUE
      };
      this.loadService.getLoadsbasedOnTypeAndSubType(params).subscribe(data => {
        const genericSensorLoadsForSite = [];
        if (data != null || data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            genericSensorLoadsForSite.push({
              'Title': data[i].name, 'RId': data[i].rId,
              'loadId': data[i].loadId, 'nodeId': data[i].loadId
            });
          }
        }
        this.immediateChildEntites = genericSensorLoadsForSite;
      });
    } else {
      this.immediateChildEntites = this.immediateChildNodes;
    }
  }

  getSensorsConnectedToGenericLoad() {
    const params = {
      'siteID': this.siteId,
      'type': Constants.LOAD_TYPE.GENERIC_OR_AREA_SPECIFIC_SENSOR.TYPE_VALUE,
      'loadId': this.nodeDetails.selectedEnity,
      // 'rId': this.nodeDetails.selectedEnity,
    };
    this.loadService.getSensorDetailsBasedOnLoadId(params).subscribe(data => {
      const sensorsConnectedToGenericLoad = [];
      if (data.Inlets != null && data.Inlets.length > 0) {
        for (let i = 0; i < data.Inlets.length; i++) {
          sensorsConnectedToGenericLoad.push({
            'Title': data.Inlets[i].name,
            'sensorNodeId': this.generateStaticNodeIdForSensor(data.Inlets[i].sensor.id)
          });
        }
      }
      this.sensorConnectedToGenericLoad = sensorsConnectedToGenericLoad;
    });
  }

  generateStaticNodeIdForSensor(id: String) {
    let result = "sensor_" + id + "_";
    let timeStamp =  Date.now();
    let randomNumber = Math.floor(Math.random() * 1000);

    return result + timeStamp + "_" + randomNumber;
  }
}
